import { Typography } from '@arsnovasystems/ars-front-lib';
import { Stack } from '@mui/material';

/**
 * Reusable Field component
 *
 * @returns JSX of the component
 */
export const Field = ({ label, value }: { label: string; value: string }) => {
  return (
    <Stack
      direction={'row'}
      sx={{ justifyContent: 'space-between' }}
    >
      <Typography
        color={'primary'}
        sx={{
          flex: 3,
          fontSize: '1.2rem',
          fontWeight: 500,
          textTransform: 'uppercase',
        }}
      >
        {label} :
      </Typography>
      <Typography
        sx={{
          flex: 3,
          fontWeight: 600,
          fontSize: '1.4rem',
        }}
      >
        {value}
      </Typography>
    </Stack>
  );
};
